import { useRoomUploadRoomPicture } from "@crowdcoursing/api/openapi";

import { useEntityAvatar, type UseEntityAvatarResult } from "./useEntityAvatar";

export const useRoomAvatar = (roomId: string | undefined): UseEntityAvatarResult => {
  const { mutateAsync: uploadRoomPicture } = useRoomUploadRoomPicture();

  return useEntityAvatar({
    entityId: roomId,
    entityType: "room",
    pathParamKey: "roomId",
    uploadPicture: uploadRoomPicture,
  });
};
